/**
 * Created by natalia.petrov on 7/31/2017.
 */
import PropTypes from 'prop-types';

import React from 'react';
import {connect} from 'react-redux';
import intlC from '../../constants/intl';
import {Helmet} from 'react-helmet';
import C from '../../constants/app';

class CustomHelmet extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        if (this.props.theme && this.props.theme.hasPreview) {
            let title = this.props.intlObject['ssp.page.title.theme.preview'];
            if (this.props.theme.id > 0 && this.props.theme.name) {
                title += `: ${this.props.theme.name}`;
            }
            return <Helmet><title>{title}</title></Helmet>
        }
        else {
            return <Helmet>{this.props.children}</Helmet>;
        }
    }
}
CustomHelmet.propTypes = {
    intlObject: PropTypes.object.isRequired,
    theme:PropTypes.object.isRequired,
    children:PropTypes.object
};
function mapStateToProps(state) {
    return {
        intlObject: state.intl.get(intlC.INTL_OBJECT),
        theme:state.app.getIn([C.THEME])
    }
}

export default connect(mapStateToProps)(CustomHelmet);


// WEBPACK FOOTER //
// ./components/utils/CustomHelmet.js